import { render } from "./PageD.vue?vue&type=template&id=132dfdf1"
import script from "./PageD.vue?vue&type=script&lang=js"
export * from "./PageD.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__